import PickQuestions from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestions";
import React from "react";

const QuizManualPickQuestions = () => {
  return (
    <div>
      <PickQuestions></PickQuestions>
    </div>
  );
};

export default QuizManualPickQuestions;
